import { message, Spin, Upload } from "@thepiquelab/archus-components-web";
import { UploadFilePath } from "@thepiquelab/web-types";
import { RcFile } from "antd/lib/upload/interface";
import React, { useEffect } from "react";
import { useUpload } from "../../hooks/upload/useUpload";
import UserAvatar, { UserAvatarProps } from "../UserAvatar/UserAvatar";

interface Props extends UserAvatarProps {
  path: UploadFilePath;
  // eslint-disable-next-line react/no-unused-prop-types
  onUploaded?: (url: string) => void;
}

const AvatarUpload: React.FC<Props> = (props) => {
  const { path, onUploaded, ...config } = props;

  const { upload, data, loading } = useUpload(path);

  useEffect(() => {
    if (data?.url) {
      onUploaded(data?.url);
    }
  }, [data?.url]);

  const handleUpload = async (file: RcFile): Promise<void> => {
    if (file) {
      const isSize = file.size / 1024 / 1024 < 1;
      if (!isSize) {
        message.warning("File size should be less than or equal to 1 MB");
      } else {
        await upload(file);
      }
    }
  };

  return (
    <div
      className="w-maxcontent h-maxcontent cursor-pointer"
      data-testid="DragUpload"
    >
      <Upload
        accept=".jpg, .jpeg, .png, .svg, .webp"
        disabled={loading}
        showUploadList={false}
        multiple={false}
        customRequest={(options) => {
          handleUpload(options.file as RcFile);
        }}
      >
        <Spin spinning={loading}>
          <UserAvatar {...{ ...config, avatarUrl: config.avatarUrl }} />
        </Spin>
      </Upload>
    </div>
  );
};

export default AvatarUpload;
